import { isNil, map } from 'lodash-es';
import { api } from '../commonApi';
import { ICreateOrderRequest, IGetOrderResponse } from '../../proto/order/order';
import { EOrderItemStatus } from '../../proto/order/orderItemStatus.enum';

const BASE_ORDER_URL = `/order`;

export const orderApi = api.injectEndpoints({
	endpoints: (builder) => ({
		createOrder: builder.mutation<void, ICreateOrderRequest>({
			query: (data) => ({ url: `${BASE_ORDER_URL}`, method: 'POST', body: data, credentials: 'include' }),
			invalidatesTags: [{ type: `Order`, id: 'LIST' }, { type: `Cart` }],
		}),
		getOrders: builder.query<IGetOrderResponse[], { tableSessionId?: string; statuses: EOrderItemStatus[] }>({
			query: ({ tableSessionId, statuses }) => {
				const params = new URLSearchParams({
					status: statuses.join(','),
				});

				if (!isNil(tableSessionId)) {
					params.append('tableSessionId', tableSessionId);
				}

				return `${BASE_ORDER_URL}?${params.toString()}`;
			},
			providesTags: (result, _, { tableSessionId }) => {
				return [
					{ type: `Order`, id: 'LIST' },
					{ type: 'Order - TABLE_SESSION', id: tableSessionId },
					...map(result, (order) => ({ type: 'Order', id: order.id })),
				];
			},
		}),
		gerOrderById: builder.query<IGetOrderResponse, { orderId: string }>({
			query: ({ orderId }) => {
				return `${BASE_ORDER_URL}/${orderId}`;
			},
			providesTags: (result, error, { orderId }) => {
				const tags = [{ type: `Order`, id: orderId }];

				if (!isNil(result?.tableSession?.id)) {
					tags.push({ type: 'Order - TABLE_SESSION', id: result.tableSession.id });
				}

				return tags;
			},
		}),
	}),
});

export const { useCreateOrderMutation, useGetOrdersQuery, useGerOrderByIdQuery } = orderApi;
